export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20221125PV_0004_MR1_3468_tn.68ac29c2.jpg";